<template>
  <div class="contenedor-pdp">
    <div class="contenedorTexto col-8 elevation-3 ma-auto">
      <nav class="lineaSuperior"></nav>
      <div class="contenedorLogo">
        <img src="../../assets/img/logo.png" class="logo mt-3 mb-2" />
      </div>
      <h1>POLÍTICA DE PRIVACIDAD Y TRATAMIENTO DE DATOS PERSONALES</h1>
      <h2 class="col-10">INTRODUCCIÓN</h2>
      <div class="col-10 ma-auto">
        <p>
          <strong>NEUMOMED SAS</strong> reconoce la importancia de brindar a
          los(as) titulares de información personal la protección adecuada en
          relación con el tratamiento de sus datos personales bajo la premisa de
          que todas las personas tienen derecho a conocer, actualizar y
          rectificar las informaciones que se hayan recogido sobre ellas en
          bancos de datos y en archivos, de conformidad con el artículo 15 de la
          Constitución Política de Colombia. Por lo anterior, se ha diseñado la
          presente Política de Tratamiento de Datos Personales, la cual refleja
          los principios y reglas establecidas en el Régimen General de
          Protección de Datos Personales con el fin de garantizar los derechos
          de las personas y demás libertades y garantías constitucionales a que
          se refiere el artículo 15 de la Constitución Política.
        </p>
      </div>
      <h2 class="col-10">ALCANCE</h2>
      <div class="col-10 ma-auto">
        <p>
          Esta política establece las directrices que
          <strong>NEUMOMED SAS</strong> ha definido para el adecuado manejo de
          los datos personales, los mecanismos para ejercer los derechos de
          los(as) stitulares de información, así como indicar las finalidades
          del tratamiento, los deberes que tiene como responsable de información
          personal y regular otros aspectos en materia de protección de datos
          personales. Estas directrices aplican a colaboradores(as),
          proveedores, prestadores, contratistas, encargados, terceros en
          general y titulares de información personal.
        </p>
      </div>
      <h2 class="col-10">DEFINICIONES</h2>
      <div class="col-10 ma-auto">
        <ul>
          <li type="disc">
            <strong>Datos públicos:</strong> es el dato que no sea privado o
            sensible. Por ejemplo: número y tipo de documento de identidad,
            información contenida en documentos públicos, estado civil, oficio o
            profesión, teléfono y correo electrónico corporativos.
          </li>
          <li type="disc">
            <strong>Datos privados:</strong> son aquellos que por su naturaleza
            íntima o reservada sólo son relevantes para el titular. Por ejemplo:
            nivel de ingresos, datos financieros, capacidad de endeudamiento,
            patrimonio bruto, personas a cargo, composición del grupo familiar,
            hobbies o aficiones, bienes que posee, información laboral,
            preferencias en redes sociales, hábitos de conducción, hábitos de
            consumo, así como datos de contacto como dirección, teléfono y
            correo electrónico personal.
          </li>
          <li type="disc">
            <strong>Datos sensibles:</strong> categoría de datos personales que
            se reducen a la categoría más íntima y sensible de su titular, cuyo
            tratamiento inadecuado, puede conllevar a la discriminación y/o al
            sufrimiento de un perjuicio grave y de difícil reparación. Por
            ejemplo: datos biométricos e historia clínica o datos relacionados
            con la salud en general.
          </li>
        </ul>
      </div>
      <h2 class="col-10">LINEAMIENTOS GENERALES</h2>
      <div class="col-10 ma-auto">
        <p>
          <strong>
            Tratamiento al cual serán sometidos los datos personales:
          </strong>
          <strong>NEUMOMED SAS</strong>usará la información personal de sus
          clientes para los fines autorizados e informados al titular y aquellos
          señalados en la presente política, siempre que el tratamiento obedezca
          a un fin legítimo y sea proporcional de acuerdo a la vinculación del
          cliente, particularmente para lo que resulte necesario para la
          prestación de los servicios encargados, como ejecutar y cumplir el
          contrato. La autorización de tratamiento de datos sensibles es
          facultativa.
        </p>
        <p>
          <strong>
            Finalidades inherentes al objeto contractual o autorizadas por
            normatividad.
          </strong>
          <strong>NEUMOMED SAS</strong>utilizará los datos personales de sus
          grupos de interés principalmente para el cumplimiento de sus funciones
          como IPS, empleador y para los fines contractuales necesarios para dar
          cumplimiento a las obligaciones legales y aquellas inherentes a las
          relaciones de índole precontractual, contractual y la poscontractual
          de conformidad con las normas que regulen la materia.
        </p>
        <p>
          Las finalidades especificas (distintas a las requeridas para prestar
          el servicio de salud) están contenidas en la autorización para el
          tratamiento que cada titular, según el grupo de interés al que
          pertenezca (afiliado(a), beneficiario(a), usuario(a), colaborador(a),
          contratista, proveedor, comunidad). A manera de ejemplo, a
          continuación, se presentan de manera general dichas finalidades:
        </p>
        <ul>
          <li type="disc">
            Enviar comunicaciones comerciales por cualquier medio físico o
            electrónico (correo, SMS, MMS, fax, WhatsApp, redes sociales, etc.)
          </li>
          <li type="disc">
            Transferir y/o transmitir internacionalmente los datos a un tercero,
            según la normatividad vigente.
          </li>
          <li type="disc">
            Realizar investigación de mercados, conocimiento del perfil
            comercial o transaccional del titular, telemercadeo, elaborar
            encuestas de satisfacción y entrevistas de opinión.
          </li>
          <li type="disc">
            Consultar y obtener información de centrales de riesgo crediticio u
            operadores de bancos de datos de información financiera, crediticia,
            comercial, de servicios y la proveniente de terceros países o
            entidades similares.
          </li>
          <li type="disc">
            Elaborar estudios técnicos, estadísticos, encuestas, análisis de
            tendencias de mercado y en general cualquier estudio técnico o de
            campo relacionado con el sector o la prestación de servicios.
          </li>
          <li type="disc">
            Crear bases de datos de acuerdo a las características y perfiles de
            los titulares de datos personales, todo de acuerdo con lo dispuesto
            en la ley.
            <p>
              Compartir su información personal distinta a la de carácter
              sensible, con aliados comerciales o estratégicos, a fin de que
              estas puedan tratarla para las mismas finalidades autorizadas en
              la presente autorización.
            </p>
          </li>
          <li type="disc">
            Gestionar todos los procesos administrativos internos en materia de
            administración de proveedores, prestadores, contratistas y
            colaboradores(as).
          </li>
          <li type="disc">
            Usar sus datos para mejorar la implementación de procesos, la
            prestación del servicio o del producto ofrecido o adquirido.
          </li>
          <li type="disc">
            Las demás finalidades que determinen en desarrollo de su objeto
            social, las cuales en todo caso serán conforme con la ley y en
            especial el cumplimiento específico en materia de protección de
            datos.
          </li>
        </ul>
        <p>
          <strong>Derechos de los titulares:</strong>de acuerdo con lo
          establecido en la Ley 1581 de 2012, los titulares tienen derecho a
          autorizar el tratamiento de sus datos personales, revocar la
          autorización, conocer los datos que son tratados, actualizarlos,
          rectificarlos cuando se considere que existe deficiencia en su
          calidad, y finalmente solicitar la supresión de datos siempre y cuando
          no exista una obligación legal o contractual de continuar con el
          tratamiento (artículo 2.2.2.25.2.8 Decreto 1074 de 2015), por ejemplo
          en el caso de las finalidades que son inherentes al objeto contratado
          y sin las cuales no es posible su ejecución.
        </p>
        <p>
          <strong>Ejercicio de los derechos sobre los datos personales:</strong>
          los titulares de la información podrán ejercer sus derechos en
          cualquier tiempo, para lo cual podrán comunicarse con la línea de
          atención al cliente xxxxxxxxxxxxxxxxxxxxx
        </p>
        <p>
          <strong>
            Principios generales que se acogen para garantizar la protección de
            los datos personales de los clientes de NEUMOMED SAS
          </strong>
        </p>
        <ul>
          <li type="disc">
            <strong>Principio de legalidad:</strong>no habrá tratamiento de
            información personal de los clientes sin observar las reglas
            establecidas en la normatividad vigente.
          </li>
          <li type="disc">
            <strong>Principio de finalidad:</strong>la incorporación de datos a
            las bases físicas o digitales de
            <strong>NEUMOMED SAS</strong> deberá obedecer a una finalidad
            legítima, la cual será oportunamente informada al titular en la
            cláusula de autorización para el tratamiento y en la política de
            privacidad.
          </li>
          <li type="disc">
            <strong>Principio de libertad:</strong>se realizarán tratamiento de
            datos personales de sus clientes cuando cuenten con la autorización
            de estos o cuando por norma exista una facultad para hacerlo, en los
            términos del art. 3° literal a) y 6° literal a) de la Ley 1581 del
            2012, así como la sección II del capítulo 25 del Decreto 1074 de
            2015.
          </li>
          <li type="disc">
            <strong>Principio de veracidad y calidad:</strong>se propenderán
            porque la información de sus clientes sea veraz y se encuentre
            actualizada, para lo cual dispondrá de medios eficientes para la
            actualización y rectificación de los datos personales.
          </li>
          <li type="disc">
            <strong>Principio de transparencia:</strong>dentro de los mecanismos
            que se establezcan para el ejercicio de los derechos de los
            titulares de la información personal, se garantizará al titular y a
            sus causahabientes, así como a los terceros autorizados por este, el
            acceso a la información sobre datos personales que le conciernan.
          </li>
          <li type="disc">
            <strong>Principio de acceso y circulación restringida:</strong>
            <strong>NEUMOMED SAS</strong> se compromete a garantizar que
            únicamente personas autorizadas podrán acceder a la información
            personal. Asimismo, su circulación se limitará al ejercicio de las
            finalidades autorizadas por el usuario o por la normatividad.
            <strong>NEUMOMED SAS</strong> dispondrán de medios contractuales
            para garantizar la confidencialidad y circulación restringida de la
            información.
          </li>
          <li type="disc">
            <strong>Principio de seguridad:</strong>
            <strong>NEUMOMED SAS</strong>adelantará todas las medidas técnicas,
            administrativas y humanas para garantizar que la información
            personal de los titulares, almacenada en bases de datos físicas o
            digitales, no circule o personas no autorizadas accedan a ella.
          </li>
          <li type="disc">
            <strong>Principio de confidencialidad:</strong> todas las personas
            que intervengan en el tratamiento de datos personales que no tengan
            la naturaleza de públicos están obligadas a garantizar la reserva de
            la información, inclusive después de finalizada su relación con
            alguna de las labores que comprende el tratamiento, pudiendo sólo
            realizar suministro o comunicación de datos personales cuando ello
            corresponda al desarrollo de las actividades autorizadas en la ley y
            en los términos de la misma.
          </li>
        </ul>
        <p>
          <strong>
            Entrega de información personal a proveedores de servicios:
          </strong>
          es posible que para cumplir con la relación contractual que
          <strong>NEUMOMED SAS</strong>sostenga con el titular de la
          información, esta sea entregada o compartida con proveedores para las
          finalidades autorizadas por el titular o las previstas en la ley,
          tales como ajustadores de siniestros, investigadores, instituciones,
          profesionales de la salud, call centers, distribuidores y
          profesionales en prevención, intermediarios de seguros y personas
          naturales o jurídicas que presten servicios profesionales para
          efectuar estadísticas, cálculos actuariales, desarrollo de software y
          cualquier otra actividad para llevar a cabo el objeto social de
          <strong>NEUMOMED SAS</strong> y prestar correctamente la atención.
          Siempre que su información sea entregada o compartida con proveedores,
          <strong>NEUMOMED SAS</strong> se asegurará de establecer unas
          condiciones que vinculen al proveedor a las políticas de privacidad y
          seguridad de la información de estas de tal forma que la información
          personal de los titulares se encuentre protegida. Asimismo, se
          establecerán acuerdos de confidencialidad para el manejo de la
          información y obligaciones responsable-encargado cuando el tipo de
          entrega lo amerite.
        </p>
        <p>
          <strong>
            Tratamiento de datos personales de niños, niñas y adolescentes
          </strong>
          <strong>NEUMOMED SAS</strong> tratará los datos de menores de edad
          previa autorización del padre, acudiente o representante legal,
          excepto cuando se trate de datos de naturaleza pública y cuando dicho
          tratamiento responda y respete el interés superior y derechos
          fundamentales de los niños, niñas y adolescentes.
        </p>
        <p>
          <strong>NEUMOMED SAS</strong> no usará los datos de menores de edad,
          para fines de mercadeo, ni se incluirán para custodia en bases de
          datos que cuenten con dicha finalidad. Cuando el(la) menor lo
          solicite, se tendrá en cuenta su opinión y voluntad de ejercer sus
          derechos o autorizar el tratamiento. Para lo cual se valorará la
          madurez, autonomía y capacidad para entender el asunto.
        </p>
        <p>
          <strong>Vigencia del tratamiento de los datos:</strong> la información
          suministrada por los titulares permanecerá almacenada por el tiempo
          que sea determinado por el titular o que sea indicado por ley para el
          cumplimiento de los fines para los cuales fue incorporada.
        </p>
        <p>
          <strong>
            Modificaciones a la política de privacidad y tratamiento de datos
            personales
          </strong>
          <strong>NEUMOMED SAS</strong> se reserva el derecho de modificar las
          normas de confidencialidad y protección de datos con el fin de
          adaptarlas a nuevos requerimientos de tipo legal, jurisprudencial,
          técnico y, en general, cuando sea necesario para prestar un mejor
          servicio.
        </p>
        <p>
          <strong>Aceptación de esta política de privacidad:</strong> el titular
          de la información acepta el tratamiento de sus datos personales,
          conforme con los términos de esta política de privacidad, cuando
          proporciona los datos a través de nuestros canales o puntos de
          atención y cuando compra, adquiere, se afilia o usa cualquiera de
          nuestros productos o servicios.
        </p>
      </div>
      <h2 class="col-10">GOBERNABILIDAD</h2>
      <div class="col-10 ma-auto">
        <p>
          La aprobación de la presente política está a cargo de la Gerencia
          General y/o representante legal.
        </p>
        <p>
          El oficial de datos de
          <strong>NEUMOMED SAS</strong>o quien haga sus veces será la instancia
          responsable del gobierno y la aplicación de esta política.
        </p>
      </div>
      <h2 class="col-10">INSTANCIAS DE DECISIÓN</h2>
      <div class="col-10 ma-auto">
        <p>
          Las instancias de decisión en materia de protección de datos
          personales estarán bajo las definiciones del oficial de datos de
          <strong>NEUMOMED SAS</strong> o quien haga sus veces, el reglamento de
          trabajo y la normatividad vigente aplicable.
        </p>
      </div>
      <h2 class="col-10">DIVULGACIÓN</h2>
      <div class="col-10 ma-auto">
        <p>
          La presente política será vinculante y deberá ser publicada a todos
          los grupos de interés, dentro de los sitios definidos por
          <strong>NEUMOMED SAS.</strong>
        </p>
        <p>
          El oficial de datos de
          <strong>NEUMOMED SAS</strong> o quien haga sus veces será el
          responsable de la administración de esta política y en esa medida
          gestionará con las áreas involucradas su divulgación, cumplimiento y
          actualización.
        </p>
      </div>
      <nav class="lineaInferior"></nav>
    </div>
    <!-- <h1>POLÍTICA DE PRIVACIDAD Y TRATAMIENTO DE DATOS PERSONALES</h1>
    <div class="articulo">
      <span class="articulo-titulo">ARTÍCULO 1o. ALCANCE.&nbsp;</span>
      <span class="articulo-texto">
        El reglamento es aplicable a los datos personales registrados en
        cualquier base de datos de NEUMOMED SAS.
      </span>
    </div>
    <div class="articulo">
      <span class="articulo-titulo">ARTÍCULO 2o. PRINCIPIOS.&nbsp;</span>
      <span class="articulo-texto">
        Para efectos de garantizar la protección de datos personales en el
        tratamiento, transferencia y transmisión de datos personales, NEUMOMED
        SAS aplicara de manera armónica e integral los siguientes
        principios:
      </span>
      <ol class="articulo-ol">
        <li class="articulo-li">
          <span class="articulo-titulo">
            Principio de legalidad en materia de tratamiento de
            datos:&nbsp;
          </span>
          <span class="articulo-texto">
            NEUMOMED SAS. dará estricto cumplimiento a las leyes vigentes y
            Normas concordantes al momento de realizar el tratamiento de los
            datos personales que se encuentren en sus bases de datos.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-titulo">Principio de finalidad:&nbsp;</span>
          <span class="articulo-texto">
            la actividad del tratamiento de datos personales que realice
            NEUMOMED SAS. o a la cual tuviere acceso, obedecerá a una finalidad
            legitima en consonancia con la Constitución Política de Colombia,
            las leyes vigentes, las presentes políticas y las disposiciones
            contractuales establecidas con el titular, sus herederos o sus
            representantes legales, la cual deberá ser informada al respectivo
            titular de los datos personales.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-titulo">Principio de libertad:&nbsp;</span>
          <span class="articulo-texto">
            el tratamiento de los datos personales sólo puede realizarse con el
            consentimiento, previo, expreso e informado del titular. Los datos
            personales no podrán ser obtenidos o divulgados sin previa
            autorización, o sin que haya un mandato legal, estatutario, o
            judicial que así lo disponga.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-titulo">Principio de veracidad o Calidad:&nbsp;</span>
          <span class="articulo-texto">
            la información sujeta a tratamiento de datos personales, debe ser
            veraz, completa, exacta, actualizada, comprobable y comprensible. No
            se realizará el tratamiento de datos parciales, incompletos,
            fraccionados o que induzcan a error.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-titulo">Principio de transparencia:&nbsp;</span>
          <span class="articulo-texto">
            para el tratamiento de datos personales, NEUMOMED SAS. proveerá al
            titular que así lo solicite, la información acerca de la existencia
            de cualquier tipo de información o dato personal que sea de su
            interés o titularidad.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-titulo">Principio de acceso y circulación restringida:&nbsp;</span>
          <span class="articulo-texto">
            el tratamiento sólo podrá hacerse por personas autorizadas por el
            titular y/o por las personas previstas en la Ley. Cuando NEUMOMED
            SAS. realice el tratamiento de datos personales en internet u otros
            medios de divulgación o comunicación masiva, propenderá porque el
            acceso sea técnicamente controlable para brindar un conocimiento
            restringido sólo a los titulares o terceros autorizados conforme a
            la Ley.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-titulo">Principio de seguridad:&nbsp;</span>
          <span class="articulo-texto">
            la información sujeta a tratamiento por NEUMOMED SAS., se deberá
            manejar con las medidas técnicas, humanas y administrativas que sean
            para otorgar seguridad a los registros evitando su adulteración,
            pérdida, consulta, uso o acceso no autorizado o fraudulento.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-titulo">Principio de confidencialidad:&nbsp;</span>
          <span class="articulo-texto">
            todas las personas que en NEUMOMED SAS. administren, manejen,
            actualicen o tengan acceso a informaciones de cualquier tipo que se
            encuentren en bases de datos, están obligadas a garantizar la
            reserva de la información, por lo tanto, se comprometen a conservar
            y mantener de manera estrictamente confidencial y no revelar a
            terceros, toda la información que llegaren a conocer en la ejecución
            y ejercicio de sus funciones, salvo cuando se trate de actividades
            autorizadas expresamente por el titular, por ley o cuando se
            obedezcan orden de una autoridad competente. Esta obligación
            persiste y se mantendrá inclusive después de finalizada su relación
            con NEUMOMED SAS.o alguna de las labores que comprende el
            tratamiento.
          </span>
        </li>
      </ol>
    </div>
    <div class="articulo">
      <span class="articulo-titulo">ARTÍCULO 3o. FINALIDADES DEL TRATAMIENTO DE DATOS.&nbsp;</span>
      <span class="articulo-texto">
        NEUMOMED SAS. utilizará los datos personales que reposan en sus bases
        de datos para el cumplimiento de sus objetivos legales y
        contractuales.
      </span>
    </div>
    <div class="articulo">
      <span class="articulo-titulo">ARTÍCULO 4o. DERECHOS DEL TITULAR.&nbsp;</span>
      <span class="articulo-texto">
        NEUMOMED SAS. y las personas a quienes este encargue el tratamiento de
        los datos personales deberán reconocer y respetar al titular, como
        mínimo, los siguientes derechos:
      </span>
      <ol class="articulo-ol">
        <li class="articulo-li">
          <span class="articulo-texto">
            Acceder, conocer, actualizar y rectificar sus datos personales que
            reposen en NEUMOMED SAS.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">Autorizar el tratamiento de sus datos personales.</span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Solicitar prueba de la autorización otorgada a NEUMOMED SAS. para
            el tratamiento de datos, mediante cualquier medio valido, salvo en
            los casos en que no es necesaria la autorización de acuerdo con la
            ley.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Ser informado por NEUMOMED SAS. o previa solicitud, respecto del
            uso que les ha dado a sus datos personales.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Presenta ante la Superintendencia de Industria y Comercio, o la
            entidad que hiciere sus veces, quejas por infracciones a los
            dispuesto en la Ley 1581 de 2012 y las demás normas que la
            modifiquen, adicionen o complementen, previo tramite de consulta o
            requerimiento a NEUMOMED SAS.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Revocar la autorización y/o solicitar la supresión de datos cuando
            en el tratamiento no se respeten los principios, derechos y
            garantías constitucionales y legales y cuando no haya obligación
            legal o contractual de permanecer en la base de datos.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Acceder en forma gratuita a sus datos personales que hayan sido
            objeto de tratamiento, al menos una vez cada mes calendario, y cada
            vez que existan modificaciones sustanciales de la presente política
            que motiven nuevas consultas. NEUMOMED SAS.se reserva la facultad de
            cobrar por esta actividad a los titulares cuando estos soliciten
            acceso a sus datos personales en más de una ocasión dentro de un
            mismo mes calendario. Las sumas de dinero que NEUMOMED SAS. cobre en
            estos casos no podrán exceder el costo del envió, reproducción, y en
            su caso, certificación de documentos. Los costos de reproducción no
            podrán ser mayores a los costos de recuperación del material
            correspondiente.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            En el caso de los niños, niñas y adolescentes, se les escuchará en
            todos los casos que involucren en tratamiento de sus datos
            personales y su opinión será tenida en cuenta de acuerdo con su
            madurez
          </span>
        </li>
      </ol>
    </div>
    <div class="articulo">
      <span class="articulo-titulo">ARTÍCULO 5o. LEGITIMACIÓN. &nbsp;</span>
      <span class="articulo-texto">Estos derechos podrán ser ejercidos por:</span>
      <ol class="articulo-ol">
        <li class="articulo-li">
          <span class="articulo-texto">
            El titular, quien deberá acreditar su identidad en forma suficiente
            por los distintos medios que le ponga a disposición NEUMOMED SAS.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Los causahabientes del titular, quienes deberán acreditar tal
            calidad.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            El representante y/o apoderado del titular, previa acreditación de
            la representación o apoderamiento.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">Otro a favor o para el cual el titular hubiere estipulado.</span>
        </li>
      </ol>
    </div>
    <div class="articulo">
      <span class="articulo-titulo">ARTÍCULO 6o. OBLIGACIONES DEL RESPONSABLE.&nbsp;</span>
      <span class="articulo-texto">
        En el tratamiento y protección de datos personales, NEUMOMED SAS. asume
        los siguientes deberes, sin perjuicio de otros previstos en las
        disposiciones que regulen o lleguen a regular esta materia:
      </span>
      <ol class="articulo-ol">
        <li class="articulo-li">
          <span class="articulo-texto">
            Garantizar al titular, en todo tiempo, el pleno y efectivo
            ejercicio del derecho de habeas data.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Solicitar y conservar copia de la respectiva autorización otorgada
            por el titular para el tratamiento de datos personales.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Informar debidamente al titular sobre la finalidad del tratamiento
            y los derechos que le asisten en virtud de la autorización otorgada.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Conservar los datos personales bajo las condiciones de seguridad
            necesarias para impedir su adulteración, perdida, consulta, uso o
            acceso no autorizado o fraudulento.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Garantizar que la información será veraz, completa, exacta,
            actualizada, comprobable y comprensible.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Suprimir los datos personales que se encuentren contenidos en los
            actos administrativos y documentos públicos cuando esta supresión
            sea posible pero que no implique el incumplimiento de otras
            disposiciones, como la ley 1712 de 2014.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Actualizar oportunamente la información atendiendo de esta forma
            todas las novedades respecto de los datos del titular.
            Adicionalmente, velara por la implementación de las medidas
            necesarias para que la información se mantenga actualizada.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Transmitir y/o transferir los datos personales que se encuentran en
            sus bases de datos solo a las personas naturales o jurídicas que se
            encuentren legal o contractualmente autorizadas para su tratamiento.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Rectificar la información cuando sea incorrecta y comunicar lo
            pertinente.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Tramitar las consultas y reclamos formulados en los términos
            señalados por la Ley.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Informar cuando determinada información se encuentra en discusión
            por parte del titular.
          </span>
        </li>
        <li class="articulo-li">
          <span
            class="articulo-texto"
          >Informar a solicitud del titular sobre el uso dado a sus datos.</span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Informar a la autoridad de protección de datos cuando se presenten
            violaciones a los códigos de seguridad y existan riesgos en la
            administración de la información de los titulares.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Cumplir los requerimientos e instrucciones que imparta la
            Superintendencia de Industria y Comercio sobre el tema en
            particular.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Usar únicamente datos cuyo tratamiento esta previamente autorizado
            de conformidad con lo previsto en la Ley 1581 de 2012.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Velar por el uso adecuado de los datos personales de los niños,
            niñas y adolescentes, en aquellos casos en que se está autorizado el
            tratamiento de sus datos.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Registrar en la base de datos la leyenda “reclamo en trámite” en la
            forma en que se regula en la ley.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Insertar en la base de datos la leyenda “información en discusión
            judicial” una vez notificado por parte de la autoridad competente
            sobre procesos judiciales relacionados con la calidad del dato
            personal.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Abstenerse de circular información que este siendo controvertida
            por el titular y cuyo bloqueo haya sido ordenado por la
            Superintendencia de Industria y Comercio.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Permitir el acceso a la información únicamente a las personas que
            pueden tener acceso a ella de acuerdo con la ley y las instrucciones
            del titular.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Tomar en cuenta la opinión del titular niño, niña o adolescente de
            acuerdo con su grado de madurez.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Conservar el soporte de los gastos de envió, reproducción y, en su
            caso, certificación de documentos, cuando estos han sido cobrados al
            titular.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Suprimir los datos personales que se encuentren en sus bases de
            datos para los cuales no tenga obligación o facultad legal o
            contractual de tratar.
          </span>
        </li>
      </ol>
    </div>
    <div class="articulo">
      <span class="articulo-titulo">ARTÍCULO 7o. FACULTADES DEL RESPONSABLE.&nbsp;</span>
      <ol class="articulo-ol">
        <li class="articulo-li">
          <span class="articulo-texto">
            Ser informado por parte del titular o sus representantes de toda
            reclamación que afecte el cumplimiento de la ley y las presentes
            políticas por parte de sus funcionarios, contratantes, contratistas,
            auxiliares y colaboradores.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Realizar el tratamiento de los datos personales que se encuentren
            en sus bases de datos para las finalidades que sean autorizadas por
            los legitimados, las establecidas en la ley y en el presente
            instrumento.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Nombrar encargados para el tratamiento de la información, los
            cuales deberán respetar lo establecido en la ley y las presentes
            políticas.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Realizar la transferencia y/o transmisión de los datos personales
            contenidos en sus bases de datos y suscribiendo los actos y
            contratos necesarios para garantizar el cumplimiento de las leyes
            vigentes y las presentes políticas.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Realizar el tratamiento, la transmisión y/o la transferencia de los
            datos personales que se encuentren en sus bases de datos, sin
            autorización previa y expresa del titular en los siguientes casos:
          </span>
          <ol class="articulo-ol" type="a">
            <li>
              <span class="articulo-texto">
                Cuando la información sea requerida por una entidad pública o
                administrativa en ejercicio de sus funciones legales o por orden
                judicial.
              </span>
            </li>
            <li>
              <span class="articulo-texto">Cuando se trate de datos de naturaleza pública.</span>
            </li>
            <li>
              <span class="articulo-texto">En casos de urgencia médica o sanitaria.</span>
            </li>
            <li>
              <span class="articulo-texto">
                Cuando el tratamiento de información sea autorizado por la ley
                para fines históricos, estadísticos o científicos; e. Cuando los
                datos estén relacionados con el registro civil de las
                personas.
              </span>
            </li>
          </ol>
        </li>
      </ol>
    </div>
    <div class="articulo">
      <span class="articulo-titulo">ARTÍCULO 8o. REVOCATORIA DEL CONSENTIMIENTO.&nbsp;</span>
      <span class="articulo-texto">
        Los titulares de los datos personales pueden en cualquier momento
        revocar total o parcialmente la autorización otorgada a NEUMOMED SAS.
        para el tratamiento de sus datos personales o solicitar la supresión
        total o parcial de los mismos, siempre y cuando no lo impida una
        disposición legal o contractual.
      </span>
      <p class="articulo-texto">
        La revocatoria del consentimiento puede expresarse de manera total en
        relación con las finalidades autorizadas, y por lo tanto NEUMOMED SAS
        deberá cesar cualquier actividad de tratamiento de los datos, o podrá
        ser de manera parcial en relación con ciertos tipos de tratamiento, en
        cuyo caso serán estos sobre los que cesarán las actividades de
        tratamiento. En este último caso NEUMOMED SAS. podrá continuar tratando
        los datos personales para aquellos fines en relación con los cuales el
        titular no hubiera revocado su consentimiento.
      </p>
    </div>
    <div class="articulo">
      <span class="articulo-titulo">ARTÍCULO 9o. TRATAMIENTO DE DATOS PERSONALES SENSIBLES.&nbsp;</span>
      <span class="articulo-texto">
        NEUMOMED SAS. podrá, en previa autorización expresa del titular, hacer
        tratamiento de datos personales sensibles en los siguientes
        eventos:
      </span>
      <ol class="articulo-ol" type="a">
        <li class="articulo-li">
          <span class="articulo-texto">
            Cuando el titular haya dado su autorización explícita, salvo en los
            casos que por ley no sea requerido el otorgamiento de dicha
            autorización.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Cuando el tratamiento sea necesario para salvaguardar el interés
            vital del titular y este se encuentre física o jurídicamente
            incapacitado.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            En estos eventos, los representantes legales deberán otorgar su
            autorización.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Cuando el tratamiento sea efectuado en el curso de las actividades
            legítimas y con las debidas garantías por parte de una fundación,
            ONG, asociación o cualquier otro organismo sin ánimo de lucro, cuya
            finalidad sea política, filosófica, religiosa o sindical, siempre
            que se refieran exclusivamente a sus miembros o a las personas que
            mantengan contactos regulares por razón de su finalidad.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            El tratamiento se refiere a datos que sean necesarios para el
            reconocimiento, ejercicio o defensa de un derecho en un proceso
            judicial.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            El tratamiento tenga una finalidad histórica, estadística o
            científica. En este evento deberán adoptarse las medidas conducentes
            a la supresión de identidad de los titulares.
          </span>
        </li>
      </ol>
    </div>
    <div class="articulo">
      <span class="articulo-titulo">ARTÍCULO 10o. PROCEDIMIENTO PARA RECLAMOS.&nbsp;</span>
      <span class="articulo-texto">
        El titular o sus causahabientes que consideren que la información
        contenida en una base de datos deber ser objeto de corrección,
        actualización o supresión, o cuando adviertan el presunto incumplimiento
        de cualquiera de los deberes contenidos en la ley, podrán presentar un
        reclamo ante NEUMOMED SAS., el cual será tramitado bajo las siguientes
        reglas:
      </span>
      <ol class="articulo-ol">
        <li class="articulo-li">
          <span class="articulo-texto">
            El reclamo del titular se formulará mediante solicitud dirigida a
            NEUMOMED SAS.al correo electrónico o mediante el uso de herramientas
            y facilidades electrónicas puestas a disposición del titular por el
            área responsable, en todo caso, el titular puede radicar su
            solicitud por escrito en la recepción de la Institución y dirigirla
            al área encargada.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">La solicitud deberá contener como mínimo:&nbsp;</span>
          <ol class="articulo-ol" type="a">
            <li>
              <span class="articulo-texto">La identificación del titular.</span>
            </li>
            <li>
              <span class="articulo-texto">
                La descripción de los hechos que dan lugar al reclamo, o
                solicitud de corrección, supresión o actualización y
                suministrara los datos correctos de ser el caso.
              </span>
            </li>
            <li>
              <span class="articulo-texto">
                La dirección física o electrónica en la que se recibirán las
                respuestas a su solicitud.
              </span>
            </li>
            <li>
              <span class="articulo-texto">Los documentos que se requiera hacer valer.</span>
            </li>
          </ol>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Si el reclamo resulta incompleto, se requerirá al interesado dentro
            de los cinco (5) días siguientes a la recepción del reclamo para que
            subsane las fallas.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Transcurridos dos (2) meses desde la fecha del requerimiento, sin
            que el solicitante presente la información requerida, se entenderá
            que ha desistido del reclamo.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            En caso de quien reciba el reclamo no sea competente para
            resolverlo, dará traslado a quien corresponda en un término máximo
            de dos (2) días hábiles e informara de la situación al interesado.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Una vez recibido el reclamo completo, este se catalogará con la
            etiqueta “reclamo en trámite” y el motivo del mismo, en un término
            no mayor a dos (2) días hábiles. Dicha etiqueta se mantendrá hasta
            que el reclamo sea decidido.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            El término máximo para atender el reclamo será de quince (15) días
            hábiles contados a partir del día siguiente a la fecha de su recibo.
            Cuando no fuere posible atender el reclamo dentro de dicho término,
            se informará al interesado los motivos de la demora y la fecha en
            que se atenderá su reclamo, la cual en ningún caso podrá superar los
            ocho (8) días hábiles siguientes al vencimiento del primer término.
          </span>
        </li>
      </ol>
    </div>
    <div class="articulo">
      <span
        class="articulo-titulo"
      >ARTÍCULO 11o. PETICIÓN DE ACTUALIZACIÓN Y/O RECTIFICACIÓN. &nbsp;</span>
      <span class="articulo-texto">
        NEUMOMED SAS.rectificará y actualizará a solicitud del titular, la
        información de este que resulte ser incompleta o inexacta de conformidad
        con el procedimiento y los términos señalados en el artículo precedente,
        para lo cual se tendrá en cuenta.
      </span>
    </div>
    <div class="articulo">
      <span class="articulo-titulo">ARTÍCULO 12o. PETICIÓN DE SUPRESIÓN DE DATOS.&nbsp;</span>
      <span class="articulo-texto">
        El titular de los datos personales tiene el derecho de solicitar a
        NEUMOMED SAS. su supresión (eliminación) en cualquiera de los siguientes
        eventos:
      </span>
      <ol class="articulo-ol">
        <li class="articulo-li">
          <span class="articulo-texto">
            Considere que los mismos no están siendo tratados conforme a los
            principios, deberes y obligaciones previstas en la normatividad
            vigente.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Hayan dejado de ser necesarios o pertinentes para la finalidad para
            la cual fueron recabados.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Se haya superado el periodo necesario para el cumplimiento de los
            fines para los que fueron recabados.
          </span>
        </li>
      </ol>
      <p class="articulo-texto">
        Esta supresión implica la eliminación total o parcial de la información
        personal de acuerdo con lo solicitado por el titular en los registros,
        archivos, bases de datos o tratamientos realizados por NEUMOMED SAS
      </p>
    </div>
    <div class="articulo">
      <span class="articulo-titulo">
        ARTÍCULO 13o. EVENTOS EN LOS QUE EL RESPONSABLE NO ESTA OBLIGADO A LA
        SUPRESIÓN DEL DATO.&nbsp;
      </span>
      <span class="articulo-texto">
        NEUMOMED SAS podrá negar el ejercicio del mismo en los siguientes
        eventos:
      </span>
      <ol class="articulo-ol">
        <li class="articulo-li">
          <span class="articulo-texto">
            El titular tenga un deber legal o contractual de permanecer en la
            base de datos.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            La eliminación de datos obstaculice actuaciones judiciales o
            administrativas vinculadas a obligaciones fiscales, la investigación
            y persecución de delitos o la actualización de sanciones
            administrativas.
          </span>
        </li>
        <li class="articulo-li">
          <span class="articulo-texto">
            Los datos sean necesarios para proteger los intereses jurídicamente
            tutelados del titular, para realizar una acción en función del
            interés público o para cumplir con una obligación legalmente
            adquirida por el titular.
          </span>
        </li>
      </ol>
    </div>
    <div class="articulo">
      <span class="articulo-titulo">
        ARTÍCULO 14o. MODIFICACIÓN A LA POLÍTICA DE PRIVACIDAD Y TRATAMIENTO DE
        DATOS PERSONALES&nbsp;
      </span>
      <span class="articulo-texto">
        NEUMOMED se reserva el derecho de modificar las normas de
        confidencialidad y protección de datos con el fin de adaptarlas a nuevos
        requerimientos de tipo legal, jurisprudencial, técnico y, en general,
        cuando sea necesario para prestar un mejor servicio.
      </span>
    </div>
    <div class="articulo">
      <span class="articulo-titulo">ARTÍCULO 15o. VIGENCIA DEL TRATAMIENTO DE DATOS:&nbsp;</span>
      <span class="articulo-texto">
        La información suministrada por los titulares permanecerá almacenada
        por el tiempo que sea determinado por el titular o que sea indicado por
        ley para el cumplimiento de los fines para los cuales fue
        incorporada.
      </span>
    </div>-->
  </div>
  <!-- <div class="articulo">
      <span class="articulo-titulo">&nbsp;</span>
      <span class="articulo-texto"></span>
      <ol class="articulo-ol">
        <li class="articulo-li">
          <span class="articulo-titulo">&nbsp;</span>
          <span class="articulo-texto"></span>
        </li>
      </ol>
  </div>-->
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "../../assets/sass/utils/mixins";
@import "../../assets/sass/utils/variables";
.contenedor-pdp {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  // align-items: center;
  width: 100vw;
  height: 100vh;
  padding: 20px;
  color: $gris-oscuro;
  .contenedorTexto {
    position: relative;
  }
  .contenedorLogo {
    text-align: -webkit-right;
    .logo {
      width: 100px;
    }
  }

  .lineaSuperior {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: 10px;
    background: #1eaaf1;
  }
  .lineaInferior {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 30px;
    background: #1eaaf1;
  }
  h1 {
    margin-bottom: 30px;
    text-align: center;
    color: #1eaaf1;
    @include for-tablet-portrait-only {
      font-size: 30px;
    }
    @include for-phone-only {
      font-size: 26px;
    }
  }
  h2 {
    color: #1eaaf1;
  }

  .articulo {
    align-self: flex-start;
    margin-bottom: 25px;
    font-size: 26px;
    @include for-tablet-portrait-only {
      font-size: 26px;
    }
    @include for-phone-only {
      font-size: 22px;
    }
    .articulo-titulo {
      font-weight: 800;
    }
    .articulo-li {
      margin-top: 10px;
      margin-left: 30px;
    }
  }
  @include pantalla-pequena {
    padding-left: 5px;
    .contenedorTexto {
      width: 100vw;
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
  }
}
</style>
